export enum FeeMissingInvestmentsOption {
  AllPlatform = "AllPlatform",
  Missing = "Missing",
  NotMissing = "NotMissing",
}
